module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("首页配置")]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "label-width": "80px",
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.actionType !== 'add'
    },
    model: {
      value: (_vm.formData.type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "type", $$v)
      },
      expression: "formData.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "首页气泡",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页通知栏",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页顶部入口背景",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "最多20个字",
      "maxlength": 20,
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), (_vm.formData.type == 1) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "图形",
      "prop": "bubbleImage"
    }
  }, [_c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=4",
      "tips": "支持jpg、png",
      "urls": _vm.formData.bubbleImage,
      "readonly": _vm.actionType === 'detail'
    },
    on: {
      "onUrls": _vm.bubbleImageUploaded
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跳转链接",
      "prop": "url"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.url),
      callback: function($$v) {
        _vm.$set(_vm.formData, "url", $$v)
      },
      expression: "formData.url"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.type == 2) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "标题图片",
      "prop": "titleImage"
    }
  }, [_c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=4",
      "tips": "支持jpg、png",
      "urls": _vm.formData.titleImage,
      "readonly": _vm.actionType === 'detail'
    },
    on: {
      "onUrls": _vm.titleImageUploaded
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文案",
      "prop": "copywriting"
    }
  }, [_c('div', {
    staticClass: "flex-row margin-bottom-20"
  }, [_c('div', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("内容")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "最多15个字",
      "maxlength": 15,
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('div', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("指引")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "最多4个字",
      "maxlength": 4,
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.guide),
      callback: function($$v) {
        _vm.$set(_vm.formData, "guide", $$v)
      },
      expression: "formData.guide"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跳转链接",
      "prop": "url"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.url),
      callback: function($$v) {
        _vm.$set(_vm.formData, "url", $$v)
      },
      expression: "formData.url"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.type == 3) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "图形",
      "prop": "backImage"
    }
  }, [_c('div', {
    staticClass: "flex-row-between"
  }, [_c('div', [_c('div', [_vm._v("我的奖牌背景")]), _vm._v(" "), _c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=4",
      "tips": "(尺寸:100px*88px,jpg、png)",
      "urls": _vm.formData.medalImage,
      "readonly": _vm.actionType === 'detail'
    },
    on: {
      "onUrls": _vm.medalImageUploaded
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', [_vm._v("数字奖牌排名背景")]), _vm._v(" "), _c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=4",
      "tips": "(尺寸:100px*88px,jpg、png)",
      "urls": _vm.formData.rankingImage,
      "readonly": _vm.actionType === 'detail'
    },
    on: {
      "onUrls": _vm.rankingImageUploaded
    }
  })], 1)])])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效时间",
      "prop": "effectiveTime"
    }
  }, [_c('div', {
    staticClass: "flex-row-between"
  }, [_c('el-date-picker', {
    attrs: {
      "placeholder": "起始日期",
      "type": "datetime",
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.startTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "startTime", $$v)
      },
      expression: "formData.startTime"
    }
  }), _vm._v(" "), _c('div', [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "placeholder": "截止日期",
      "type": "datetime",
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.endTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "endTime", $$v)
      },
      expression: "formData.endTime"
    }
  })], 1)])], 1)], 1), _vm._v(" "), (_vm.actionType !== 'detail') ? _c('div', {
    staticClass: "margin-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSaveAndPublish
    }
  }, [_vm._v("保存并发布")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a5f2646!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/PingAn/HomeConfigAddition.vue
// module id = 958
// module chunks = 0